module.exports = __webpack_public_path__ + "img/C350Icon.ce073758.png";